module.exports = __webpack_public_path__ + "static/media/logo.0ba4eb43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EnergyCompany/img/logo.svg
// module id = 993
// module chunks = 0